import { ConfigStore, STR_ERRORS } from "../..";
import { getChannelData } from "../getChannelData";
export function getRequestProps(connName, message) {
    const connectionURL = ConfigStore.config.urls[connName];
    let baseUrl;
    let headerParams = {};
    let skipAppendSiteName = false;
    if (typeof connectionURL === "object") {
        baseUrl = connectionURL.baseUrl;
        skipAppendSiteName = Boolean(connectionURL.skipAppendSiteName);
        headerParams = connectionURL.headerParams || {};
    }
    else {
        baseUrl = connectionURL;
    }
    if (typeof baseUrl === "undefined") {
        throw new Error(STR_ERRORS.InvalidBaseUrl);
    }
    const { channel, method, params, meta } = getChannelData(connName, message, skipAppendSiteName);
    if (meta) {
        for (const key of Object.keys(meta)) {
            headerParams[key] = meta[key];
        }
    }
    return {
        baseUrl,
        endpoint: channel,
        method,
        headers: headerParams,
        body: undefined,
        params
    };
}
//# sourceMappingURL=getRequestProps.js.map